<template>
  <section 
    class="mt-2" 
    v-if="rfq && (estimationHasWall || estimationHasRailing)">

    <h1>Cost and Benefit Breakdown</h1>
    <hr class="h1-underline"/>

    <div class="content--nobreak" v-if="estimationHasWall">
      <h2>
        Solar Cladding Cost Breakdown (Total and per SQFT)
      </h2>
      <tax-incentives
        :estimation="estimation"
        :has-mpa-price="hasMpaPrice"
        :has-dpa-price="hasDpaPrice"/>
    </div>

    <div class="content--nobreak" v-if="estimationHasRailing">
      <h2>
        Solar Railing Cost Breakdown (Total and per LF)
      </h2>
      <tax-incentives
        :estimation="estimation"
        :has-mpa-price="hasMpaPrice"
        :has-dpa-price="hasDpaPrice"
        rail-or-wall="rail"/>
    </div>

    <div class="mb-3" v-if="costBreakdownOne" v-html="costBreakdownOne">
    </div>

    <div v-if="costBreakdownTwo" v-html="costBreakdownTwo">
    </div>
    
  </section>
</template>

<script>
import TaxIncentives from '@/components/proposalmaker/TaxIncentives'

export default {
  props: {
    costBreakdownOne: {
      type: [String, Number],
      default: null
    },
    costBreakdownTwo: {
      type: [String, Number],
      default: null
    },
    rfq: {
      type: Object
    },
    hasMpaPrice: {
      type: Boolean
    },
    hasDpaPrice: {
      type: Boolean
    }
  },
  components: { TaxIncentives },
  computed: {
    estimation({ rfq }) {
      return rfq.c_estimation ? rfq.c_estimation : rfq.estimation;
    },
    estimationHasWall({ estimation }) {
      return Object.keys(estimation.estimation_summary).includes('solar_wall_active');
    },
    estimationHasRailing({ estimation }) {
      return estimation.estimation_summary.summary.filter(
        d => d.pricing_summary.includes('railing')
      ).length > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';
</style>
